module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/7mill-active-0f00e71f9f8dd1c1bc75a1394a19f919.png";